import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp32} ${props => props.theme.spacing.sp16};
  text-align: center;
`
